module.exports = __webpack_public_path__ + "static/media/ic-no-connect.b271beb6.svg";